module.exports = __webpack_public_path__ + "static/media/school_money-logo--text-right.8ba3d6da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/school_money-logo--text-right.svg
// module id = 103
// module chunks = 0